import { render, staticRenderFns } from "./FaturamentoView.vue?vue&type=template&id=4e32af34&"
import script from "./FaturamentoView.vue?vue&type=script&lang=js&"
export * from "./FaturamentoView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports